package com.routexk.quiz.ui.components.widgets

import androidx.compose.runtime.*
import com.routexk.quiz.ui.components.buttons.PrimaryButton
import com.routexk.quiz.ui.components.buttons.SecondaryButton
import com.routexk.quiz.ui.theme.AppColors
import com.routexk.quiz.ui.utils.Constants
import com.routexk.quiz.utils.Storage
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.silk.components.forms.ButtonSize
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.animation.Keyframes
import com.varabyte.kobweb.silk.style.animation.toAnimation
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import org.jetbrains.compose.web.css.*

private const val COOKIE_CONSENT_KEY = "cookie_consent"

val CookieSlideUpKeyframes = Keyframes {
    from {
        Modifier.translateY(100.percent).opacity(0)
    }
    to {
        Modifier.translateY(0.percent).opacity(1)
    }
}

@Composable
fun CookieConsent(
    modifier: Modifier = Modifier
) {
    var isVisible by remember { mutableStateOf(!Storage.contains(COOKIE_CONSENT_KEY)) }

    if (!isVisible) return

    val colorMode = ColorMode.current
    val colors = AppColors.getColors(colorMode)

    Box(
        modifier = modifier
            .position(Position.Fixed)
            .bottom(0.px)
            .left(0.px)
            .right(0.px)
            .zIndex(999)
            .padding(16.px)
            .animation(
                CookieSlideUpKeyframes.toAnimation(
                    duration = Constants.ANIMATION_NORMAL.ms,
                    timingFunction = AnimationTimingFunction.EaseOut
                )
            ),
        contentAlignment = Alignment.BottomCenter
    ) {
        Box(
            modifier = Modifier
                .maxWidth(900.px)
                .fillMaxWidth()
                .backgroundColor(colors.surface)
                .borderRadius(12.px)
                .padding(20.px, 24.px)
                .styleModifier {
                    property("box-shadow", "0 -4px 24px rgba(0, 0, 0, 0.2)")
                    property("border", "1px solid ${colors.border}")
                }
        ) {
            Row(
                modifier = Modifier.fillMaxWidth().gap(16.px),
                verticalAlignment = Alignment.CenterVertically,
                horizontalArrangement = Arrangement.SpaceBetween
            ) {
                Column(
                    modifier = Modifier.fillMaxWidth().gap(4.px),
                ) {
                    SpanText(
                        "We use cookies",
                        modifier = Modifier
                            .fontSize(16.px)
                            .color(colors.textPrimary)
                    )
                    SpanText(
                        "This website uses cookies to ensure you get the best experience.",
                        modifier = Modifier
                            .fontSize(14.px)
                            .color(colors.textSecondary)
                    )
                }

                Row(
                    modifier = Modifier.gap(8.px),
                    verticalAlignment = Alignment.CenterVertically
                ) {
                    SecondaryButton(
                        text = "Decline",
                        onClick = {
                            Storage.save(COOKIE_CONSENT_KEY, "declined")
                            isVisible = false
                        },
                        size = ButtonSize.MD
                    )
                    PrimaryButton(
                        text = "Accept",
                        onClick = {
                            Storage.save(COOKIE_CONSENT_KEY, "accepted")
                            isVisible = false
                        },
                        size = ButtonSize.MD
                    )
                }
            }
        }
    }
}
